import React, { useState } from 'react';
import { AdminCourseCard } from '../../components/CourseCard';
import { ButtonLink, Card, PageHeader, StatusBadge } from '../../components/ui';
import { useLms } from '../../context/LmsContext';

export default function AdminCourses() {
  const { data, currentUser, deleteCourse } = useLms();
  const [status, setStatus] = useState('all');
  const [category, setCategory] = useState('all');
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState('');
  const courses = data.courses.filter((course) => {
    const statusOk = status === 'all' || course.status === status;
    const categoryOk = category === 'all' || course.category === category;
    const queryOk = !query || `${course.title} ${course.description} ${course.category} ${course.status}`.toLowerCase().includes(query.trim().toLowerCase());
    return statusOk && categoryOk && queryOk;
  });

  const handleDeleteCourse = (course) => {
    const activeAssignments = data.assignments.filter((assignment) => assignment.courseId === course.id && assignment.status !== 'revoked').length;
    const revokedAssignments = data.assignments.filter((assignment) => assignment.courseId === course.id && assignment.status === 'revoked').length;
    const details = activeAssignments
      ? `\n\nThis course has ${activeAssignments} active/completed learner record(s). Revoke those assignments first before deleting the course.`
      : revokedAssignments
        ? `\n\nThis will also remove ${revokedAssignments} revoked learner assignment record(s) tied to this course.`
        : '';
    if (!window.confirm(`Delete course "${course.title}"? This cannot be undone.${details}`)) return;
    const result = deleteCourse(course.id, currentUser.id);
    setMessage(result.ok ? `Course "${course.title}" deleted.` : result.message);
  };

  return (
    <>
      <PageHeader
        title="Course governance"
        eyebrow="Admin"
        description="Approve, publish, archive, assign, and monitor all company training courses."
        action={<ButtonLink to="/trainer/courses/new">Create course</ButtonLink>}
      />
      {message && <Card><p className="feedback-box compact-feedback">{message}</p></Card>}
      <Card>
        <div className="toolbar">
          <label>Search <input className="search-input" placeholder="Search course title, description, category, or status" value={query} onChange={(e) => setQuery(e.target.value)} /></label>
          <label>Status <select value={status} onChange={(e) => setStatus(e.target.value)}><option value="all">All</option><option value="draft">Draft</option><option value="in_review">In Review</option><option value="published">Published</option><option value="archived">Archived</option></select></label>
          <label>Category <select value={category} onChange={(e) => setCategory(e.target.value)}><option value="all">All</option>{data.categories.map((item) => <option key={item}>{item}</option>)}</select></label>
          <div className="legend-row"><StatusBadge status="draft" /><StatusBadge status="in_review" /><StatusBadge status="published" /><StatusBadge status="archived" /></div>
        </div>
      </Card>
      <div className="course-grid">
        {courses.map((course) => <AdminCourseCard key={course.id} data={data} course={course} onDelete={handleDeleteCourse} />)}
      </div>
    </>
  );
}
